// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__9O+IH","tabItem":"styles_tabItem__4JiXy","active":"styles_active__ke0Wz","inActive":"styles_inActive__PvLVg"};